<template>
  <div class="p--40px">
    <h1 class="font--32px lh--1 pb--20px">고객사</h1>
    <form
      @submit.prevent="submit"
      @input="error.errorMessage = ''"
    >
      <text-field-input
        label="회사ID"
        name="companyId"
        placeholder="회사ID을 입력하세요."
        v-model="row.companyId"
        :error="error"
        :readonly="isEditMode"
      ></text-field-input>

      <text-field-input
        label="회사명"
        name="companyName"
        placeholder="회사명을 입력하세요."
        v-model="row.companyName"
        :error="error"
      ></text-field-input>

      <text-field-input
        label="서브 도메인"
        name="subDomain"
        placeholder="서브 도메인을 입력하세요."
        v-model="row.subDomain"
        :error="error"
      ></text-field-input>

      <text-field-input
        label="E-Mail"
        name="email"
        placeholder="E-Mail을 입력하세요."
        v-model="row.email"
        :error="error"
      ></text-field-input>

      <div class="pt--20px text--center">
        <button
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="goList"
        >
          돌아가기
        </button>

        <button
          type="submit"
          class="btn btn--xxxl black text--white ml--4px"
        >저장하기</button>
      </div>
    </form>

  </div>
</template>

<script>
export default {
  data () {
    return {
      row: {
        logos: []
      },
      origin: {},
      error: {},
      uploadStatus: ''
    }
  },
  computed: {
    isEditMode () {
      return !!this.companyId
    },
    companyId () {
      return this.$route.params.companyId
    }
  },
  created () {
    if (this.isEditMode) {
      this.$load(`/api/companys/${this.companyId}`)
    }
  },
  methods: {
    async submit () {
      // this.$emit('submit')
      try {
        if (!this.isEditMode) {
          await this.$create(`/api/companys`)
        } else {
          let ret = await this.$update(`/api/companys/${this.row.companyId}`)
          if (!ret) {
            return
          }
          ret = confirm('수정되었습니다. 목록으로 이동하시겠습니까?')
          if (ret) {
            this.goList()
          }
        }
        this.$router.push({ name: 'adminCompany' })
      } catch (error) {
        this.error = error
      }
    },
    goList () {
      this.$router.push({ name: 'adminCompany' })
    },
    removeFile (idx) {
      this.row.logos = this.row.logos.filter((file, index) => index !== idx)
    },
    onFileError (err) {
      console.log('err', err)
      this.error = err
    },
    onFileUpload (uploadStatus) {
      this.uploadStatus = uploadStatus
    }
  },
  components: {
    TextFieldInput: () => import('@/component/ui2/textfield/TextFieldInput')
  }
}
</script>
